/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Settings_ProviderInputs */

const vi_einvoice_settings_provider = /** @type {(inputs: Einvoice_Settings_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhà cung cấp`)
};

/**

* @param {Einvoice_Settings_ProviderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_settings_provider = /** @type {((inputs?: Einvoice_Settings_ProviderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Settings_ProviderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_settings_provider(inputs)
});